import React from 'react';
import './project.css';
import NavBar from '../../componets/navbar/navbar.js';
import { Container, Row, Col } from 'react-bootstrap';
import ImageGallery from 'react-image-gallery';
import nl2br from 'react-newline-to-break';
import { getProjectBySlug } from '../../services/contentService';

const defaultImage = '/content/Home/1.jpg';
const fallbackGalleryItems = [
  {
    original: defaultImage,
    thumbnail: defaultImage
  }
];

function extractFirstNumberFromUrl(link) {
  try {
    const fileName = decodeURIComponent(link.split('/').pop() || '').replace(/\.[^.]+$/, '');
    const match = fileName.trim().match(/(\d+)/);
    return match ? Number(match[1]) : null;
  } catch (_) {
    return null;
  }
}

function sortLinksByLeadingNumber(links) {
  return [...links].sort((a, b) => {
    const aNum = extractFirstNumberFromUrl(a);
    const bNum = extractFirstNumberFromUrl(b);

    if (aNum !== null && bNum !== null && aNum !== bNum) {
      return aNum - bNum;
    }

    if (aNum !== null && bNum === null) return -1;
    if (aNum === null && bNum !== null) return 1;

    return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
  });
}

function buildGalleryItems(project) {
  const galleryLinks = sortLinksByLeadingNumber((project.gallery || []).filter(Boolean));
  const links = galleryLinks.length
    ? galleryLinks
    : (project.thumbnailUrl ? [project.thumbnailUrl] : [defaultImage]);

  return links.map((link) => ({
    original: link,
    thumbnail: link
  }));
}

class ProjectPage extends React.Component {
   constructor(props) {
    super(props);
    const images = fallbackGalleryItems
                
    this.state = {
        images: images,
        project : { id:'', title: '', client:'', location:'', status:'', description: '' },
      isfetch : false,
      notFound: false
    };

    this.renderLeftNav = this.renderLeftNav.bind(this);

  }
  async componentDidMount(){
    try{
      const { id } = this.props.match.params
      const slug = decodeURIComponent(id);
      const project = await getProjectBySlug(slug);
      if(project) {
        const list = buildGalleryItems(project);

        this.setState({
          project,
          images: list,
          isfetch:true
        });
      } else {
        this.setState({ isfetch: true, notFound: true });
      }
    } catch(err){
      console.log(err);
      this.setState({ isfetch: true, notFound: true });
    }
  }

  getNotFound() {
    return (
      <div className='project'>
        <NavBar />
        <div className='loading loading-text'>
          Project not found.
        </div>
      </div>
    );
  }

  getSuccess(){
    return (
    <div className="project">
        <NavBar />
        <Container fluid>
          <Row className="project-summary">
          <Col xs lg="2" className='project-details'>
            <Row>

                    <div className="project-title">
                    {this.state.project.title}
                    </div>
                    </Row>
                    {/* <Row>
                    <div className="project-details-hint">
                    Client
                    </div>
                    </Row>
                    <Row>
                    <div className="project-details-value">
                    {this.state.project.client}
                    </div>
                    </Row> */}
                    {/* <Row>
                    <div className="project-details-hint">
                    Status
                    </div>
                    </Row>
                    <Row>
                    <div className="project-details-value">
                    {this.state.project.status}
                    </div> 
                    </Row>  */}
                    {/* <Row>
                    <div className="project-details-hint">
                    Location
                    </div>
                    </Row> */}
                    <Row>
                    <div className="project-details-hint">
                    {this.state.project.location}
                    </div>
                    </Row>
                    <Row>
                    <div className="project-details-hint">
                    {this.state.project.projectTimeline}
                    </div>
                    </Row>
                    </Col>
            <Col className="details"> 
                <div className="carousel">
                 <ImageGallery className="gallery" items={this.state.images} disableSwipe={false}/>
                </div>
                <div className="project-description">
                {nl2br(this.state.project.description)} </div>
            </Col>
          </Row>
        </Container> 
      </div>
      );
  }
  renderLeftNav(onClick, disabled) {
    return (
      <button
        className='image-gallery-custom-left-nav'
        disabled={disabled}
        onClick={onClick}/>
    )
  }

  getloading(){
   return(
      <div className="project">
        <NavBar/>
        <div className = 'loading loading-text'>
        Loading project...
        </div>
    </div>
   );
  }

  render() {
      const response = !this.state.isfetch
        ? this.getloading()
        : this.state.notFound
          ? this.getNotFound()
          : this.getSuccess();
      return(
        <div>
        {response}
        </div>
      );
  }
}

export default ProjectPage;



